import {useEffect, useState} from "react";
import { apiRequest } from "../../network/apiClient";
import {API_ENDPOINTS} from "../../api/apiEndpoints";

export const useAccDetContact = ({leadID}) => {
    const [contactData, setContactData] = useState([]);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const fetchData = async () =>{
        
        try{
            const queryParams = new URLSearchParams({
                lead_id: leadID
            })
            const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_ACCOUNTS.CONTACTS}?${queryParams.toString()}`, 'GET');

            setContactData(result.contact_data);
        }catch (error){
            if (error.response?.status === 404) {
                setError("Data not found");
            } else {
                console.error("Error fetching data:", error);
                setError(error);
            }
        }finally{
            setIsLoading(false);
        }
    };
    useEffect(() =>{
        fetchData();
    }, [leadID]);
    return {contactData, error, isLoading, refetch: fetchData};
}
